import { render, staticRenderFns } from "./SendMessageOtherUserHistory.vue?vue&type=template&id=69eaa8be&scoped=true&lang=pug"
import script from "./SendMessageOtherUserHistory.vue?vue&type=script&lang=ts"
export * from "./SendMessageOtherUserHistory.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageOtherUserHistory.vue?vue&type=style&index=0&id=69eaa8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eaa8be",
  null
  
)

export default component.exports